import { useState } from 'react'
import { IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY

interface Props {
  lat: number
  lng: number
  heading?: number
  onClose: () => void
}

const StreetViewPanel = ({ lat, lng, heading = 0, onClose }: Props) => {
  const [dragging, setDragging] = useState(false)
  const [pos, setPos] = useState({ x: 16, y: 96 })
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 })

  const embedUrl = `https://www.google.com/maps/embed/v1/streetview?location=${lat},${lng}&heading=${Math.round(heading)}&pitch=0&fov=90&key=${GOOGLE_KEY}`

  const googleMapsUrl = `https://www.google.com/maps/@${lat},${lng},3a,75y,${Math.round(heading)}h,90t/data=!3m1!1e3`

  const handleMouseDown = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).closest('button')) return
    if ((e.target as HTMLElement).tagName === 'IFRAME') return
    setDragging(true)
    setDragStart({ x: e.clientX - pos.x, y: e.clientY - pos.y })
  }

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!dragging) return
    setPos({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y })
  }

  const handleMouseUp = () => setDragging(false)

  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      style={{
        position: 'fixed',
        left: pos.x,
        top: pos.y,
        zIndex: 9000,
        backgroundColor: 'white',
        borderRadius: 8,
        boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
        userSelect: 'none',
        overflow: 'hidden',
      }}
    >
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '4px 8px', backgroundColor: '#333', color: 'white',
        cursor: dragging ? 'grabbing' : 'grab',
      }}>
        <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
          Street View
        </Typography>
        <div>
          <IconButton size="small" onClick={() => window.open(googleMapsUrl, '_blank')}
            sx={{ color: 'white', p: '2px' }}>
            <OpenInNewIcon sx={{ fontSize: 16 }} />
          </IconButton>
          <IconButton size="small" onClick={onClose} sx={{ color: 'white', p: '2px' }}>
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </div>
      </div>
      <iframe
        title="Street View"
        src={embedUrl}
        width={480}
        height={360}
        style={{ border: 0, display: 'block' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', p: '2px', color: '#666', fontSize: '0.7em' }}>
        {lat.toFixed(5)}, {lng.toFixed(5)}
      </Typography>
    </div>
  )
}

export default StreetViewPanel
